import { put } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';

const key = 'AUTH/SAYCODE';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchSayCode(client) {
  try {
    const response = yield client.post('/user/auth/sayCode');
    yield put(actions.loadSuccess(response.result));
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
